import ProductManager from '../features/catalog/ProductManager';

export default function ProductsPage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Ürün Kataloğu</h1>
          <p>Menü öğelerini tüm restoranlar için oluşturun, güncelleyin ve arşivleyin.</p>
        </div>
      </header>
      <section className="page-section">
        <ProductManager />
      </section>
    </div>
  );
}
